import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AppInfo } from './appInfo.model';

@Injectable({
  providedIn: 'root'
})
export class InfoService {

  private subject: Subject<AppInfo> = new Subject();
  private subjectToast: Subject<AppInfo> = new Subject();

  constructor() {
  }

  getSubject(): Observable<AppInfo> {
    return this.subject.asObservable();
  }

  getSubjectToast(): Observable<AppInfo> {
    return this.subjectToast.asObservable();
  }

  showInfo(infoMessage: string, messages?: Array<string>): void {
    const appInfo: AppInfo = {
      infoMessage,
      messages
    };
    this.subject.next(appInfo);
  }

  showToast(infoMessage: string, messages?: Array<string>): void {
    const appInfo: AppInfo = {
      infoMessage,
      messages
    };
    this.subjectToast.next(appInfo);
  }

}
